import React, { useState, useEffect, useCallback, useRef, useImperativeHandle } from 'react';
import { CountrySelect } from '../CountrySelect';
import { Country, defaultCountry } from '../../../utils/countries';
import { MaskTypes } from '../../../interfaces';

export interface InputRefProps {
  getValue: () => string;
  setValue: (newValue: string) => void;
  focus: () => void;
}

interface InputProps extends Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'value' | 'onChange'> {
  mask?: MaskTypes;
  noUpperCase?: boolean;
  isPassword?: boolean;
  error?: any;
  options?: any;
  isAdm?: boolean;
  theme?: string;
  value?: Country;
  onChange?: (country: Country) => void;
}

const SelectCountry: React.ForwardRefRenderFunction<InputRefProps, InputProps> = (
  props,
  ref
) => {
  const {
    mask,
    isAdm,
    error,
    options = { onChange: () => { } },
    style = {},
    isPassword = false,
    noUpperCase = false,
    onKeyDown = () => { },
    onChange = () => { },
    value,
    theme,
    ...rest
  } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const [selectedCountry, setSelectedCountry] = useState<Country>(() => value || defaultCountry);

  useEffect(() => {
    if (value) {
      setSelectedCountry(value);
    }
  }, [value]);

  const getValue = useCallback(() => {
    if (mask === "m2") {
      let value_input: any = inputRef.current?.value
        ? inputRef.current?.value
        : "";
      value_input = value_input.replace(/\D/g, "");
      if (value_input !== "") value_input = Number.parseInt(value_input) / 100;
      return value_input;
    } else return inputRef.current?.value ? inputRef.current?.value : "";
  }, [mask]);

  const focus = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  const setValue = useCallback(
    (newValue: string) => {
      if (inputRef && inputRef.current) inputRef.current.value = newValue;
    },
    []
  );

  const handleOnChange = useCallback(
    (country: Country) => {
      setSelectedCountry(country);
      onChange(country);
    },
    [onChange]
  );

  useImperativeHandle(ref, () => ({
    getValue,
    setValue,
    focus
  }), [getValue, setValue, focus]);

  return (
      <CountrySelect
        ref={inputRef}
        disabled={props?.disabled}
        isAdm={isAdm}
        theme={theme}
        value={selectedCountry}
        {...rest}
        {...options}
        onChange={handleOnChange}
      />
  );
};

export default React.forwardRef(SelectCountry);